import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "data-item__header" };
const _hoisted_2 = { class: "data-item__nav" };
const _hoisted_3 = ["title"];
const _hoisted_4 = ["title"];
const _hoisted_5 = ["title"];
const _hoisted_6 = ["title"];
const _hoisted_7 = { class: "data-item__topic" };
const _hoisted_8 = { class: "data-item__title" };
const _hoisted_9 = { class: "data-item__meta" };
const _hoisted_10 = { class: "data-item__facts" };
const _hoisted_11 = { class: "data-item__actions" };
const _hoisted_12 = { class: "data-item__content" };
const _hoisted_13 = { class: "data-item__section" };
const _hoisted_14 = { class: "data-item__section-title mb-4" };
const _hoisted_15 = { class: "row" };
const _hoisted_16 = { class: "col col-lg-3" };
const _hoisted_17 = { class: "data-item__section-subtitle" };
const _hoisted_18 = {
    key: 0,
    class: "col col-lg-3"
};
const _hoisted_19 = { class: "data-item__section-subtitle" };
const _hoisted_20 = {
    key: 1,
    class: "col col-lg-3"
};
const _hoisted_21 = { class: "data-item__section-subtitle" };
const _hoisted_22 = { class: "order__comment" };
const _hoisted_23 = { class: "data-item__section" };
const _hoisted_24 = { class: "data-item__section-title mb-4" };
const _hoisted_25 = { class: "order-items" };
const _hoisted_26 = { class: "table table--condensed" };
const _hoisted_27 = { class: "order-items__title" };
const _hoisted_28 = { class: "order-items__money" };
const _hoisted_29 = { class: "order-items__money" };
const _hoisted_30 = ["onClick"];
const _hoisted_31 = { class: "order-items__image" };
const _hoisted_32 = ["src"];
const _hoisted_33 = { class: "order-items__title" };
const _hoisted_34 = { class: "order-items__sku" };
const _hoisted_35 = { class: "order-items__delivery" };
const _hoisted_36 = { class: "order-items__quantity" };
const _hoisted_37 = { class: "order-items__money" };
const _hoisted_38 = { class: "order-items__money" };
import { onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from "vue-router";
import orderRepository from "../services/OrderRepository";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
import OrderTotal from "@astina/paloma-shop-common-ui/src/components/OrderTotal.vue";
import AppAddress from "@astina/paloma-shop-common-ui/src/components/AppAddress.vue";
import Fact from "@astina/paloma-common-ui/src/components/Fact.vue";
import ProductUtils from "@astina/paloma-shop-common-ui/src/services/ProductUtils";
import events from '@astina/paloma-common-ui/src/services/EventBus';
import RepeatOrder from "../commands/RepeatOrder";
import userSettings, {} from '@astina/paloma-common-ui/src/services/UserSettings';
import RouterUtils from "@astina/paloma-common-ui/src/util/RouterUtils";
import config from '../services/PortalConfig';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderView',
    emits: [
        'close',
        'prev',
        'next'
    ],
    setup(__props, { emit: __emit }) {
        const route = useRoute();
        const router = useRouter();
        const emit = __emit;
        const settings = userSettings('paloma-ui.portal.orders');
        const order = ref(null);
        const images = ref({});
        const deliveryDates = ref([]);
        const repeatOrder = ref(null);
        const userSettingsValue = ref(null);
        const showComment = ref(config.showCartComment);
        const showCustomerOrderNumber = ref(config.showCartCustomerOrderNumber);
        onMounted(() => {
            loadOrder();
            userSettingsValue.value = settings.get({ expanded: false });
        });
        watch(() => route.params, loadOrder);
        function loadOrder() {
            order.value = null;
            const orderNumber = RouterUtils.singleParam(route, 'orderNumber');
            if (orderNumber && orderNumber !== '') {
                orderRepository.get(orderNumber).then(o => {
                    order.value = o;
                    createImages();
                    createDeliveryDates();
                    repeatOrder.value = order.value.status !== 'draft'
                        ? new RepeatOrder(order.value.orderNumber)
                        : null;
                    window.setTimeout(() => {
                        events.$emit('orders.activate-if-none-active', o.id);
                    }, 500); // HACK: give the DataTable event listener time to register
                });
            }
        }
        function createImages() {
            images.value = {};
            order.value.items
                .filter(item => item.image)
                .forEach(item => {
                const image = ProductUtils.createImage(item.image);
                if (image) {
                    images.value[item.sku] = image;
                }
            });
        }
        function determineEffectiveTargetDate(order, item) {
            return item.deliveryTargetDate ?? order.shipping.targetDate;
        }
        function createDeliveryDates() {
            deliveryDates.value = [];
            order.value.items.forEach(item => {
                const effectiveTargetDate = determineEffectiveTargetDate(order.value, item);
                if (effectiveTargetDate && deliveryDates.value.indexOf(effectiveTargetDate) === -1) {
                    deliveryDates.value.push(effectiveTargetDate);
                }
            });
            deliveryDates.value.sort();
        }
        function onItemSelect(item) {
            router.push({ name: 'catalog', query: { sku: item.sku } }).catch(() => {
            });
        }
        function toggleExpanded() {
            if (userSettingsValue.value) {
                userSettingsValue.value.expanded = !userSettingsValue.value.expanded;
                settings.set(userSettingsValue.value);
            }
        }
        // --
        function closeView() {
            emit('close');
        }
        function prevItem() {
            emit('prev');
        }
        function nextItem() {
            emit('next');
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["data-item order", { 'order--loading': !order.value, 'data-item--expanded': userSettingsValue.value && userSettingsValue.value.expanded }])
            }, [
                _createElementVNode("header", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("a", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (toggleExpanded()), ["prevent"])),
                            class: "data-item__nav-item data-item__expand",
                            title: _ctx.$t(userSettingsValue.value && userSettingsValue.value.expanded ? 'collapse' : 'expand'),
                            href: ""
                        }, [
                            _createVNode(Icon, {
                                name: userSettingsValue.value && userSettingsValue.value.expanded ? 'compress' : 'expand'
                            }, null, 8, ["name"])
                        ], 8, _hoisted_3),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (prevItem()), ["prevent"])),
                            class: "data-item__nav-item",
                            title: _ctx.$t('prev'),
                            href: ""
                        }, [
                            _createVNode(Icon, { name: "angle-left" })
                        ], 8, _hoisted_4),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (closeView()), ["prevent"])),
                            class: "data-item__nav-item",
                            title: _ctx.$t('close'),
                            href: ""
                        }, [
                            _createVNode(Icon, { name: "times" })
                        ], 8, _hoisted_5),
                        _cache[6] || (_cache[6] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (nextItem()), ["prevent"])),
                            class: "data-item__nav-item",
                            title: _ctx.$t('next'),
                            href: ""
                        }, [
                            _createVNode(Icon, { name: "angle-right" })
                        ], 8, _hoisted_6)
                    ]),
                    _cache[14] || (_cache[14] = _createTextVNode()),
                    (order.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$dateTime(order.value.orderDate)), 1),
                            _cache[12] || (_cache[12] = _createTextVNode()),
                            _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.$t('order.orderNumber')) + " " + _toDisplayString(order.value.orderNumber), 1),
                            _cache[13] || (_cache[13] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createVNode(Fact, {
                                        label: _ctx.$t('order.status'),
                                        value: _ctx.$t('order.status.' + order.value.status),
                                        variant: 'status-' + order.value.status
                                    }, null, 8, ["label", "value", "variant"]),
                                    _cache[7] || (_cache[7] = _createTextVNode()),
                                    (order.value.customer && order.value.customer.lastName)
                                        ? (_openBlock(), _createBlock(Fact, {
                                            key: 0,
                                            label: _ctx.$t('created_by'),
                                            value: order.value.customer.firstName + ' ' + order.value.customer.lastName
                                        }, null, 8, ["label", "value"]))
                                        : _createCommentVNode("", true),
                                    _cache[8] || (_cache[8] = _createTextVNode()),
                                    (order.value.origin && order.value.origin !== 'unknown')
                                        ? (_openBlock(), _createBlock(Fact, {
                                            key: 1,
                                            label: _ctx.$t('order.origin'),
                                            value: _ctx.$trans('order.origin.' + order.value.origin, undefined, order.value.origin)
                                        }, null, 8, ["label", "value"]))
                                        : _createCommentVNode("", true),
                                    _cache[9] || (_cache[9] = _createTextVNode()),
                                    (showCustomerOrderNumber.value && order.value.customerOrderNumber && order.value.customerOrderNumber !== 'unknown')
                                        ? (_openBlock(), _createBlock(Fact, {
                                            key: 2,
                                            label: _ctx.$t('order.customerOrderNumber'),
                                            value: _ctx.$trans('order.customerOrderNumber.' + order.value.customerOrderNumber, undefined, order.value.customerOrderNumber)
                                        }, null, 8, ["label", "value"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _cache[11] || (_cache[11] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_11, [
                                    (repeatOrder.value)
                                        ? (_openBlock(), _createBlock(CommandButton, {
                                            key: 0,
                                            command: repeatOrder.value,
                                            classes: ['button', 'button--outline']
                                        }, null, 8, ["command"]))
                                        : _createCommentVNode("", true),
                                    _cache[10] || (_cache[10] = _createTextVNode()),
                                    (_ctx.$isGranted('PORTAL_DELIVERIES_VIEW') && order.value.deliveries.length > 0)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            (order.value.status !== 'draft' && order.value.orderNumber)
                                                ? (_openBlock(), _createBlock(_component_router_link, {
                                                    key: 0,
                                                    to: { name: 'deliveries_delivery', params: { id: order.value.deliveries[0].id }, query: { order: order.value.orderNumber } },
                                                    class: "button button--outline"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('orders.show_deliveries')), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["to"]))
                                                : _createCommentVNode("", true)
                                        ], 64))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ], 64))
                        : (_openBlock(), _createBlock(Spinner, {
                            key: 1,
                            loading: !order.value
                        }, null, 8, ["loading"]))
                ]),
                _cache[37] || (_cache[37] = _createTextVNode()),
                _createElementVNode("div", _hoisted_12, [
                    (order.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.$t('orders.delivery')), 1),
                                _cache[20] || (_cache[20] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("h4", _hoisted_17, _toDisplayString(_ctx.$t('orders.recipient')), 1),
                                        _cache[15] || (_cache[15] = _createTextVNode()),
                                        _createVNode(AppAddress, {
                                            address: order.value.shipping.address
                                        }, null, 8, ["address"])
                                    ]),
                                    _cache[18] || (_cache[18] = _createTextVNode()),
                                    (deliveryDates.value && deliveryDates.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            _createElementVNode("h4", _hoisted_19, _toDisplayString(_ctx.$t('orders.delivery_date')), 1),
                                            _cache[16] || (_cache[16] = _createTextVNode()),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deliveryDates.value, (deliveryDate, index) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                    _createTextVNode(_toDisplayString(_ctx.$date(deliveryDate)) + _toDisplayString(index === deliveryDates.value.length - 1 ? '' : ', '), 1)
                                                ], 64));
                                            }), 256))
                                        ]))
                                        : _createCommentVNode("", true),
                                    _cache[19] || (_cache[19] = _createTextVNode()),
                                    (showComment.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                            _createElementVNode("h4", _hoisted_21, _toDisplayString(_ctx.$t('order.comment')), 1),
                                            _cache[17] || (_cache[17] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_22, _toDisplayString(order.value.comment || '–'), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _cache[36] || (_cache[36] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.$t('orders.articles')), 1),
                                _cache[34] || (_cache[34] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("table", _hoisted_26, [
                                        _createElementVNode("thead", null, [
                                            _createElementVNode("tr", null, [
                                                _cache[21] || (_cache[21] = _createElementVNode("th", null, null, -1)),
                                                _cache[22] || (_cache[22] = _createTextVNode()),
                                                _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$t('order_item_product')), 1),
                                                _cache[23] || (_cache[23] = _createTextVNode()),
                                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('orders.expected_item_delivery')), 1),
                                                _cache[24] || (_cache[24] = _createTextVNode()),
                                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('orders.item_quantity')), 1),
                                                _cache[25] || (_cache[25] = _createTextVNode()),
                                                _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.$t('orders.unit_price')), 1),
                                                _cache[26] || (_cache[26] = _createTextVNode()),
                                                _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.$t('orders.item_price')), 1)
                                            ])
                                        ]),
                                        _cache[33] || (_cache[33] = _createTextVNode()),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.value.items, (item, index) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: index,
                                                    onClick: _withModifiers(($event) => (onItemSelect(item)), ["prevent"])
                                                }, [
                                                    _createElementVNode("td", _hoisted_31, [
                                                        (images.value[item.sku])
                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                key: 0,
                                                                src: images.value[item.sku].url,
                                                                alt: ""
                                                            }, null, 8, _hoisted_32))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _cache[28] || (_cache[28] = _createTextVNode()),
                                                    _createElementVNode("td", _hoisted_33, [
                                                        _createVNode(_component_router_link, {
                                                            to: { name: 'catalog', query: { sku: item.sku } }
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(item.name), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["to"]),
                                                        _cache[27] || (_cache[27] = _createTextVNode()),
                                                        _createElementVNode("span", _hoisted_34, _toDisplayString(item.sku), 1)
                                                    ]),
                                                    _cache[29] || (_cache[29] = _createTextVNode()),
                                                    _createElementVNode("td", _hoisted_35, [
                                                        (item.deliveryTargetDate)
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _createTextVNode(_toDisplayString(_ctx.$date(item.deliveryTargetDate)) + " ", 1),
                                                                (item.deliveryTargetSlot)
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                        _createTextVNode("\n                                            (" + _toDisplayString(item.deliveryTargetSlot) + ")\n                                        ", 1)
                                                                    ], 64))
                                                                    : _createCommentVNode("", true)
                                                            ], 64))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _cache[30] || (_cache[30] = _createTextVNode()),
                                                    _createElementVNode("td", _hoisted_36, _toDisplayString(item.quantity) + " " + _toDisplayString(_ctx.$unit(item)) + " " + _toDisplayString(item.portions ? _ctx.$t('orders.item_portions', { portions: item.portions }) : ''), 1),
                                                    _cache[31] || (_cache[31] = _createTextVNode()),
                                                    _createElementVNode("td", _hoisted_37, _toDisplayString(order.value.currency) + " " + _toDisplayString(item.unitPrice), 1),
                                                    _cache[32] || (_cache[32] = _createTextVNode()),
                                                    _createElementVNode("td", _hoisted_38, _toDisplayString(order.value.currency) + " " + _toDisplayString(item.linePrice), 1)
                                                ], 8, _hoisted_30));
                                            }), 128))
                                        ])
                                    ])
                                ]),
                                _cache[35] || (_cache[35] = _createTextVNode()),
                                _createVNode(OrderTotal, {
                                    currency: order.value.currency,
                                    totals: order.value.totals,
                                    "tax-included": order.value.taxIncluded
                                }, null, 8, ["currency", "totals", "tax-included"])
                            ])
                        ], 64))
                        : _createCommentVNode("", true)
                ])
            ], 2));
        };
    }
});
